export default {
  namespaced: true,
  state: {
    language: 'en',
    title: '',
    user: {
      name: null,
      role: null,
      alarms: []
    }
  },
  getters: {
    isAdmin: state => state.user.role === 'ADMIN',
    userHasAlarm: state => alarmType => (state.user.alarms.find(({ parameter }) => parameter === alarmType) || {}).value
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language
    },
    setTitle(state, title) {
      state.title = title
    },
    setServerName(state, server_name) {
      state.server_name = server_name
    },
    setDashboardName(state, dashboard_name) {
      state.dashboard_name = dashboard_name
    },
    setListName(state, list_name_title) {
      state.list_name_title = list_name_title
    },
    setUiElementName(state, ui_element_name) {
      state.ui_element_name = ui_element_name
    },
    setUser(state, user) {
      state.user.name = user.name
      state.user.login = user.login
      state.user.alarms = user.alarms || []
      if (user.role) {
        state.user.role = user.role
      }
    },
    clearUser(state) {
      state.user = {
        name: null,
        role: null
      }
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('setLanguage', language)
    },
    setTitle({ commit }, title) {
      commit('setTitle', title)
    },
    setServerName({ commit }, server_name) {
      commit('setServerName', server_name)
    },
    setDashboardName({ commit }, dashboard_name) {
      commit('setDashboardName', dashboard_name)
    },
    setListName({ commit }, list_name_title) {
      commit('setListName', list_name_title)
    },
    setUiElementName({ commit }, ui_element_name) {
      commit('setUiElementName', ui_element_name)
    },
    setUser({ commit }, user) {
      commit('setUser', user)
    },
    setUserAlarms({ state, commit }, alarms) {
      commit('setUser', {
        ...state.user,
        alarms
      })
    },
    clearUser({ commit }) {
      commit('clearUser')
    }
  }
}
